import $ from "jquery"

export function htmlDecode(input) {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = input;
    return textArea.value;
}

export function htmlEncode(input) {
    const textArea = document.createElement("textarea");
    textArea.innerText = input;
    return textArea.innerHTML.split("<br>").join("\n");
}

export function ReportDesc(input) {
    var div = $('<div />');
    div.append(input);
    div.find('*').each(function () {
      $(this).css('font-size', '16px');
      $(this).css('font-family', 'Arial');
    });
    return div.html();
}